<section class="profile-dialog">
  <header class="profile-hero">
    <div class="profile-avatar-wrap">
      <img [src]="avatar" [alt]="'Foto de ' + name" class="profile-avatar">
      @if (user.online) {
        <span class="profile-online-dot" aria-label="En línea"></span>
      }
    </div>
    <div class="profile-identity">
      <span class="profile-kicker">{{ (isOwnProfile ? 'USER.PROFILE.MY_PROFILE' : 'USER.PROFILE.TEAM_PROFILE') | translate }}</span>
      <h2>{{ name }}</h2>
      <p>{{ department }}</p>
      @if (email) {
        <a [href]="'mailto:' + email">{{ email }}</a>
      }
    </div>
  </header>

  <form class="profile-form" (ngSubmit)="save()">
    @if (isOwnProfile) {
      <p class="form-intro">{{ 'USER.PROFILE.INTRO' | translate }}</p>

      <label class="profile-field">
        <span>{{ 'USER.PROFILE.FUNCTION' | translate }} <small>· {{ profile.profileTitle.length }}/60</small></span>
        <input
          name="profileTitle"
          type="text"
          maxlength="60"
          [(ngModel)]="profile.profileTitle"
          [placeholder]="'USER.PROFILE.FUNCTION_HINT' | translate">
      </label>

      <label class="profile-field">
        <span>{{ 'USER.PROFILE.AVAILABILITY' | translate }} <small>· {{ profile.profileStatus.length }}/80</small></span>
        <input
          name="profileStatus"
          type="text"
          maxlength="80"
          [(ngModel)]="profile.profileStatus"
          [placeholder]="'USER.PROFILE.AVAILABILITY_HINT' | translate">
      </label>

      <label class="profile-field">
        <span>{{ 'USER.PROFILE.SUPPORT' | translate }} <small>· {{ profile.profileSupport.length }}/120</small></span>
        <input
          name="profileSupport"
          type="text"
          maxlength="120"
          [(ngModel)]="profile.profileSupport"
          [placeholder]="'USER.PROFILE.SUPPORT_HINT' | translate">
      </label>

      <label class="profile-field">
        <span>{{ 'USER.PROFILE.ABOUT' | translate }} <small>· {{ profile.profileAbout.length }}/240</small></span>
        <textarea
          name="profileAbout"
          rows="3"
          maxlength="240"
          [(ngModel)]="profile.profileAbout"
          [placeholder]="'USER.PROFILE.ABOUT_HINT' | translate"></textarea>
      </label>
    } @else {
      <div class="profile-detail">
        <span>{{ 'USER.PROFILE.FUNCTION' | translate }}</span>
        <strong>{{ profile.profileTitle || ('USER.PROFILE.NO_INFO' | translate) }}</strong>
      </div>
      <div class="profile-detail">
        <span>{{ 'USER.PROFILE.AVAILABILITY' | translate }}</span>
        <strong>{{ profile.profileStatus || ('USER.PROFILE.NO_INFO' | translate) }}</strong>
      </div>
      <div class="profile-detail">
        <span>{{ 'USER.PROFILE.SUPPORT' | translate }}</span>
        <strong>{{ profile.profileSupport || ('USER.PROFILE.NO_INFO' | translate) }}</strong>
      </div>
      <div class="profile-detail profile-detail--about">
        <span>{{ 'USER.PROFILE.ABOUT' | translate }}</span>
        <p>{{ profile.profileAbout || ('USER.PROFILE.NO_ABOUT' | translate) }}</p>
      </div>
    }

    @if (saveError) {
      <p class="profile-error" role="alert">{{ saveError }}</p>
    }

    <footer class="profile-actions">
      @if (isOwnProfile) {
        <button pButton type="submit" [label]="(saving ? 'USER.PROFILE.SAVING' : 'USER.PROFILE.SAVE') | translate" icon="pi pi-check" [disabled]="saving"></button>
      }
      <button pButton type="button" class="p-button-text" [label]="(isOwnProfile ? 'COMMON.CANCEL' : 'COMMON.CLOSE') | translate" (click)="close()" [disabled]="saving"></button>
    </footer>
  </form>
</section>
